export const GATES = {
  ADVANCED_SEARCH: 'SupportSpace:AdvancedSearch:FE',
  ADD_TO_THREAD: 'ServicePortals::SupportPortal::AddToThread'
};